module.exports = __webpack_public_path__ + "static/img/a4.8458619.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet/a4.png
// module id = MjCJ
// module chunks = 0